var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-stores"}},[_c('block-header-standard',{attrs:{"title":this.title[_vm.locale]}}),_c('news-list',{attrs:{"categories":_vm.$store.state.newsFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }